<p>admin-popup-setup works!</p>
